import { COMMAND_MENU_QUERY_NODE_TYPE } from '#pplx/frontend/composer-sdk/lexical/nodes/CommandMenuQueryNode.js';
import { SLASH_HINT_NODE_TYPE } from '#pplx/frontend/composer-sdk/lexical/nodes/SlashHintNode.js';
function removeSlashHintsFromSerializedNode(node) {
    if (node.type === SLASH_HINT_NODE_TYPE || node.type === COMMAND_MENU_QUERY_NODE_TYPE) {
        return null;
    }
    const nodeWithChildren = node;
    if (!Array.isArray(nodeWithChildren.children))
        return node;
    const children = nodeWithChildren.children
        .map(removeSlashHintsFromSerializedNode)
        .filter((child) => child !== null);
    const childrenChanged = children.length !== nodeWithChildren.children.length ||
        children.some((child, index) => child !== nodeWithChildren.children?.[index]);
    if (!childrenChanged)
        return node;
    return { ...nodeWithChildren, children };
}
function removeSlashHintsFromSerializedEditorState(editorState) {
    const root = removeSlashHintsFromSerializedNode(editorState.root);
    return {
        ...editorState,
        root: (root ?? editorState.root),
    };
}
export function getSerializableEditorState(editorState) {
    return removeSlashHintsFromSerializedEditorState(editorState.toJSON());
}
//# sourceMappingURL=SlashCommandHintPluginSupport.js.map